import React from 'react';
import strings from '../../lang/strings.js';
import { PageSettings } from "../../config/page-settings";
import { withRouter } from 'react-router-dom';
import { inject } from 'mobx-react';
import { Panel, PanelBody, PanelHeader } from '../../components/panel/panel.jsx';
import DataTable from './../../components/content/data-table.jsx';
import SearchInput from './../../components/content/search-input.js';
import SearchSelect from './../../components/content/search-select.js';
import $ from 'jquery';
import './../../config/util';
import Const from './../../config/const';
import BoardAutoEditPopup from './auto-edit-popup.js';
const queryString = require('query-string');

class BoardAuto extends React.Component {
    static contextType = PageSettings;

    constructor(props) {
        super(props);

        let searchQS = queryString.parse(this.props.location.search);

        this.state = {
            search_info: searchQS,
            show_edit_popup: false,
            board_data: null,
        };

        this.refreshTable = this.refreshTable.bind(this);
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.location.search != this.props.location.search) {
            let searchQS = queryString.parse(this.props.location.search);
            this.setState({ search_info: searchQS }, () => this.refreshTable());
        }
    }

    refreshTable = (refresh) => {
        this.tblMember.draw(refresh);
    };

    searchTable = () => {
        let searchQS = queryString.parse(this.props.location.search);
        Object.assign(searchQS, this.state.search_info)
        const new_query = queryString.stringify(searchQS);
        if (new_query == this.props.location.search.substr(1)) {
            this.refreshTable();
        } else {
            this.props.history.push('?' + new_query);
        }
    }

    showDetailPopup(data) {
        this.setState({
            show_edit_popup: true,
            board_data: data
        });
    }

    deleteBoard(id) {
        let self = this;
        this.context.showConfirm(strings.confirm_delete_title, function (response) {
            if (response) {
                self.context.post('board/deleteAutoItem', { id }, function () {
                    self.context.addNotification('success', strings.alert_title, strings.confirm_delete_done);
                    self.refreshTable(false);
                }, true);
            }
        });
    }

    render() {
        let self = this;
        let columnNo = 0;
        const { search_info } = this.state;

        return (
            <div>
                <Panel>
                    <PanelHeader noButton={true}>자동글 목록</PanelHeader>
                    <PanelBody>
                        <BoardAutoEditPopup
                            isOpen={this.state.show_edit_popup}
                            data={this.state.board_data}
                            onClose={() => {
                                this.setState({ show_edit_popup: false });
                            }} onSave={() => {
                                this.setState({ show_edit_popup: false });
                                this.refreshTable(false);
                            }}
                        />
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='form-horizontal form-inline'>
                                    <select className='form-control'
                                        value={search_info.category || ''}
                                        onChange={(e) => {
                                            this.setState({
                                                search_info: {
                                                    ...search_info,
                                                    category: e.target.value,
                                                    start: 0,
                                                }
                                            }, this.searchTable);
                                        }}
                                    >
                                        <option value="">{strings.select_category}</option>
                                        {strings.const.BOARD_CATEGORY.map((entry, index) => (
                                            <option key={index} value={entry}>{entry}</option>
                                        ))}
                                    </select>
                                    {/* 키워드검색 */}
                                    <SearchSelect
                                        data={[
                                            { code: 'title', name: strings.title },
                                            { code: 'content', name: strings.content },
                                        ]}
                                        value={search_info.column || 'title'}
                                        onChange={(value) => {
                                            this.setState({
                                                search_info: {
                                                    ...search_info,
                                                    column: value,
                                                    start: 0,
                                                }
                                            }, this.searchTable);
                                        }}
                                    />
                                    <SearchInput
                                        value={search_info.keyword}
                                        onChange={(value) => {
                                            this.setState({
                                                search_info: {
                                                    ...search_info,
                                                    keyword: value,
                                                    column: search_info.column || 'title',
                                                    start: 0,
                                                }
                                            })
                                        }}
                                        handler={(value) => this.searchTable()}
                                    />

                                    <button type='button' className='btn btn-success btn-sm ml-md-2' onClick={() => this.searchTable()}>{strings.search}</button>

                                    <button type='button' className='btn btn-danger btn-sm ml-md-2' onClick={() => {
                                        self.showDetailPopup(null);
                                    }}>{strings.add}</button>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 mt-3'>
                                <DataTable ref={(ref) => this.tblMember = ref}
                                    customPaginate={true}
                                    initialPage={search_info.start || 0}
                                    onPageChange={(value) => {
                                        this.setState({
                                            search_info: {
                                                ...search_info,
                                                start: value,
                                            }
                                        }, this.searchTable);
                                    }}
                                    options={{
                                        columnDefs: [
                                            {
                                                targets: [columnNo++], data: 'id', orderable: false,
                                                render: function (value) {
                                                    return value;
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'category', orderable: false,
                                                render: function (value) {
                                                    return value;
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'title', orderable: false,
                                                createdCell: function (td, value, item) {
                                                    $(td).html('');
                                                    $(td).append(`<a href="javascript:;">${value}</a>`)
                                                    if (item.status == -1) {
                                                        $(td).append(`<span style="color: red"> [${strings.deleted}]</span>`)
                                                    }
                                                    $(td).find('a')
                                                        .on('click', function () {
                                                            self.showDetailPopup(item);
                                                        });
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'content', orderable: false,
                                                render: function (value) {
                                                    return '<pre>' + value + '</pre>';
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'image_urls', orderable: false,
                                                createdCell: function (td, value, item) {
                                                    if (value) {
                                                        return $(td).image_lightbox(value, () => {
                                                            self.context.showGallery(value.split('#').map((it) => { return Const.BASE_URL + it }))
                                                        });
                                                    } else {
                                                        return $(td).html('');
                                                    }
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'gender', orderable: false,
                                                render: function (value) {
                                                    if (value == 'M') {
                                                        return '<span class="male">남자용</a>';
                                                    } else if (value == 'F') {
                                                        return '<span class="female">여자용</a>';
                                                    } else {
                                                        return '전체';
                                                    }
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'id', orderable: false,
                                                createdCell: function (td, value, item) {
                                                    $(td).html('');
                                                    $(td).append(`<button type='button' class='btn btn-danger btn-sm m-2'>${strings.delete}</button>`)
                                                        .find('button')
                                                        .on('click', function () {
                                                            self.deleteBoard(item.id);
                                                        });
                                                }
                                            }
                                        ],
                                        order: [[1, 'DESC']],
                                        ajax: {
                                            url: 'board/getAutoList',
                                            data: function (req) {
                                                req.columns = null;

                                                const searchQS = queryString.parse(self.props.location.search);
                                                req.start = searchQS.start || 0;
                                                req.length = searchQS.length || 20;
                                                req.type = searchQS.type;
                                                req.column = searchQS.column;
                                                req.keyword = searchQS.keyword;
                                            }
                                        },
                                        drawCallback: function () {
                                        },
                                        fnCreatedRow: function (row, data, dataInd) {
                                        }
                                    }}>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>{strings.category}</th>
                                            <th>{strings.title}</th>
                                            <th width="35%">{strings.content}</th>
                                            <th>{strings.image}</th>
                                            <th>{strings.gender}</th>
                                            <th>{strings.manage}</th>
                                        </tr>
                                    </thead>
                                    <tbody />
                                </DataTable>
                            </div>
                        </div>
                    </PanelBody>
                </Panel>
            </div>
        )
    }
}

export default withRouter(inject('rootStore')(BoardAuto));